module.exports = __webpack_public_path__ + "static/brynn.391bdbff.png";


//////////////////
// WEBPACK FOOTER
// ./src/bios/img/brynn.png
// module id = 231
// module chunks = 35783957827783 107818501498521